/**
 * Firebase Configuration for Simby Platform
 * Project: simby-2
 */

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyD-RZ_rH-IgbqGPX4kkwCF3m7bhDGDtGZc",
    authDomain: "simby-2.firebaseapp.com",
    databaseURL: "https://simby-2-default-rtdb.firebaseio.com",
    projectId: "simby-2",
    storageBucket: "simby-2.firebasestorage.app",
    messagingSenderId: "610255048156",
    appId: "1:610255048156:web:9632a21fae297366b25319",
    measurementId: "G-GEE0CGFZT7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
export const auth = getAuth(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
    prompt: 'select_account'
});

export default app;
